import React from "react";
import { Button, Col, Container, Jumbotron, Row } from "react-bootstrap";
import "./AboutClub.css";
const AboutClub = () => {
  return (
    <Jumbotron className="about_club mb-0" id="about">
      <Container>
        <Row className="d-flex justify-content-center align-items-center">
          <Col xs={12} md={6} >
            <div className="about_img rounded-circle"></div>
          </Col>
          <Col xs={12} md={6}>
            <h2 className="brand_text">About Club</h2>
            <p style={{ lineHeight: "1.8rem" }}>
              Lorem ipsum, dolor sit amet consectetur adipisicing elit.
              Accusamus placeat facilis iusto, nulla officiis velit repudiandae
              aliquid unde doloribus maiores nisi totam eligendi nihil laborum
              expedita. Sunt ut esse vel, expedita, repellendus voluptatum, vero
              odio libero nam id magni voluptates consequuntur necessitatibus
              nesciunt iste et dolorem quidem quo dignissimos perferendis!
            </p>
            <button>Learn More</button>
          </Col>
        </Row>
      </Container>
    </Jumbotron>
  );
};

export default AboutClub;
